<template>
  <header
    class="sticky top-0 bg-white dark:bg-[#182235] border-b border-slate-200 dark:border-slate-700 z-30"
    class.state="dark ? 'dark' : ''"
  >
    <div class="px-4 sm:px-6 lg:px-8">
      <div class="flex items-center justify-between h-16 -mb-px">
        <div class="flex">
          <router-link class="flex items-center" to="/">
            <img
              width="64"
              height="64"
              src="@/assets/WX-One_official_header.svg"
            />
            <p class="text-lg font-medium">Pricing Calculator</p>
          </router-link>
        </div>

        <CurrencySwitcher/>
      </div>
    </div>
  </header>
</template>

<script>
import CurrencySwitcher from './CurrencySwitcher.vue';

export default {
  components: {
    CurrencySwitcher,
  },
};
</script>

<style lang="scss" scoped></style>
